'use client';
import { jsx } from 'react/jsx-runtime';
import { cx } from '@chakra-ui/utils/cx';
import { motion } from 'framer-motion';
import { useDialogStyles, useDialogContext } from './dialog-context.mjs';
import { fadeConfig } from '../transition/fade.mjs';
import { chakra } from '../system/factory.mjs';
import { forwardRef } from '../system/forward-ref.mjs';

const StyledDiv = chakra(motion.div);
const DialogOverlay = forwardRef(
  function DialogOverlay2(props, ref) {
    const { transition, motionProps: _motionProps, ...rest } = props;
    const styles = useDialogStyles();
    const api = useDialogContext();
    const defaultMotionProps = api.motionPreset === "none" ? {} : fadeConfig;
    const motionProps = _motionProps || defaultMotionProps;
    return /* @__PURE__ */ jsx(
      StyledDiv,
      {
        ...motionProps,
        ...rest,
        __css: styles.overlay,
        ref,
        className: cx("chakra-dialog__overlay", props.className)
      }
    );
  }
);
DialogOverlay.displayName = "DialogOverlay";

export { DialogOverlay };
